"use client"

import { cn } from "@/lib/utils"
import type { BillingInterval } from "@/features/billing/plans"
import { selfServeAnnualPrepayExplanation } from "@/features/billing/plan-public-display"

export type BillingIntervalToggleProps = {
  value: BillingInterval
  onChange: (next: BillingInterval) => void
  className?: string
}

export function BillingIntervalToggle({
  value,
  onChange,
  className,
}: BillingIntervalToggleProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <div
        className="inline-flex rounded-full border border-border bg-muted/40 p-1"
        role="group"
        aria-label="Billing period"
      >
        {(
          [
            ["monthly", "Monthly"],
            ["annual", "Annual"],
          ] as const
        ).map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className={cn(
              "type-button min-w-[7.5rem] rounded-full px-4 py-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              value === key
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-muted-foreground hover:bg-background/80 hover:text-foreground",
            )}
          >
            {label}
          </button>
        ))}
      </div>
      {value === "annual" ? (
        <p className="type-caption text-muted-foreground">
          {selfServeAnnualPrepayExplanation()}
        </p>
      ) : null}
    </div>
  )
}
